const properties = [
  'candidate',
  'comment',
  'title',
  'placeholder',
  'titleStyle',
  'type',
  'value',
];

export default {
  properties,
};
